import React, { useState } from "react";
import Modal from "react-modal";

// Set app element for accessibility
Modal.setAppElement("#root");

const GenericModal = ({ link, buttonText = "Open Modal", modalTitle = "Modal" }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <div>
            <button onClick={openModal} style={{ padding: "10px 20px", fontSize: "16px" }}>
                {buttonText}
            </button>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel={modalTitle}
                style={{
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "80%",
                        height: "80%",
                    },
                }}
            >
                <button onClick={closeModal} style={{ marginBottom: "10px", fontSize: "16px" }}>
                    Close
                </button>

                <iframe
                    src={link}
                    title={modalTitle}
                    style={{ width: "100%", height: "90%", border: "none" }}
                ></iframe>
            </Modal>
        </div>
    );
};

export default GenericModal;
